import React from 'react';
import './pagefooter.css';
import { Helmet } from 'react-helmet-async';

const Terms = () => (
  <>
    <Helmet>
      <title>Terms & Conditions | Aikyam Sports Science</title>
      <meta
        name="description"
        content="Read the terms and conditions of Aikyam Sports Science covering our sports science services, mobile applications, timing gates, and website usage."
      />
      <meta
        name="keywords"
        content="Aikyam Sports Science terms, app terms of service, sports science services terms, timing gates terms and conditions, Udupi sports training"
      />
      <meta
        property="og:title"
        content="Terms & Conditions | Aikyam Sports Science"
      />
      <meta
        property="og:description"
        content="Terms and conditions for using Aikyam Sports Science products, software, and mobile applications."
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://aikyamsports.com/terms"
      />
      <link
        rel="canonical"
        href="https://aikyamsports.com/terms"
      />
    </Helmet>
    <div className="policy-page">
      <h1>Terms & Conditions</h1>
      <p>Welcome to Aikyam Sports Science. By accessing or using our website, mobile applications, and services, you agree to be bound by the following terms and conditions. Please read them carefully.</p>
      <ul>
        <li><strong>Services & Hardware:</strong> We provide timing gate products, hardware ecosystems, and fitness services, including athlete monitoring, injury prevention, and performance analysis.</li>
        <li><strong>Software & Mobile Applications:</strong> These terms govern your use of our mobile applications (including Aikyam Sports, Reactive Rehab, and Restore) and software dashboards. You agree to use the software only for its intended sports performance and rehabilitation tracking purposes.</li>
        <li><strong>User Accounts:</strong> To use our apps, you may be required to create an account. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</li>
        <li><strong>Product Use:</strong> Our hardware timing gates are designed for speed and jump assessments and should be used strictly as per the provided instructions and synchronized via our official applications.</li>
        <li><strong>Intellectual Property:</strong> All content, logos, app designs, and product designs are the property of Aikyam Sports Science and may not be used, copied, or reverse-engineered without permission.</li>
        <li><strong>Limitation of Liability:</strong> We are not liable for any physical injuries, data loss, or damages resulting from the misuse of our hardware, software, or mobile applications.</li>
        <li><strong>Changes to Terms:</strong> We reserve the right to update these terms at any time. Continued use of our services or apps constitutes acceptance of the new terms.</li>
        <li><strong>Contact:</strong> For any questions or support regarding our apps or hardware, please contact us at +916363202281 or +917019386664.</li>
      </ul>
      <p>Location: Center for Sports Science, Mahatma Gandhi Stadium, Ajjarakad, Brahmagiri, Udupi, Karnataka - 576101</p>
    </div>
  </>
);

export default Terms;